import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M27 7H5C3.89543 7 3 7.89543 3 9V23C3 24.1046 3.89543 25 5 25H27C28.1046 25 29 24.1046 29 23V9C29 7.89543 28.1046 7 27 7Z"
            fill="#F9EAA9"
            stroke="#A37D26"
            strokeWidth="2"
        />
        <path
            d="M7.26563 19.0781H9.59376V20.8125C9.59376 21.2344 9.87501 21.5235 10.2813 21.5235C10.6875 21.5235 10.9688 21.2344 10.9688 20.8125V19.0781H13.2969C13.5703 19.0781 13.75 18.875 13.75 18.6094C13.75 18.3438 13.5703 18.1406 13.2969 18.1406H10.9688V16.8906H13.2969C13.5703 16.8906 13.75 16.6875 13.75 16.4219C13.75 16.1563 13.5703 15.9531 13.2969 15.9531H11.4297L14 12C14.1016 11.836 14.1406 11.7031 14.1406 11.5469C14.1406 11.1953 13.8438 10.9297 13.4531 10.9297C13.1953 10.9297 12.9844 11.0391 12.8438 11.2891L10.3047 15.4453H10.2578L7.42188 11.2891C7.28125 11.0391 7.07031 10.9297 6.8125 10.9297C6.42188 10.9297 6.125 11.1953 6.125 11.5469C6.125 11.7031 6.16406 11.8359 6.26562 12L9.13282 15.9531H7.26563C6.99219 15.9531 6.81251 16.1563 6.81251 16.4219C6.81251 16.6875 6.99219 16.8906 7.26563 16.8906H9.59376V18.1406H7.26563C6.99219 18.1406 6.81251 18.3438 6.81251 18.6094C6.81251 18.875 6.99219 19.0781 7.26563 19.0781Z"
            fill="#6E4D15"
        />
        <path
            d="M17 7V13M17 24V19M17 19H29M17 19V13M17 13H29"
            stroke="#A37D26"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
